module.exports = __webpack_public_path__ + "static/media/hm6.b9fbe115.PNG";